/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import Badge from '@mui/material/Badge';
import { Typography } from '@mui/material';
import {
  Add as AddIcon,
  Close as CloseIcon,
  PlaylistAdd as PlaylistAddIcon,
  Check as CheckIcon
} from '@mui/icons-material';
import { observer } from 'mobx-react-lite';
import '../../pages/buildings/Building.sass';
import Fade from '@mui/material/Fade';
import useStores from '../../stores/useStores';
import SpeedMenu from '../speedMenu/SpeedMenu';

const ProjectSpeedDial = ({ history, match }) => {
  const { buildingId } = match.params;
  const { buildingStore, uiStore, editorStore, mapStore } = useStores();

  const { isSpeedDialOpen } = uiStore;
  const { features } = editorStore;
  const { pickedResults } = buildingStore;
  const isUpload = match.path === '/project/upload';
  const [mode, setMode] = useState('default');
  const [propertyCount, setPropertyCount] = useState(0);

  useEffect(() => {
    setPropertyCount(
      Array.from(pickedResults.data_).filter(item => item !== null).length
    );
  }, [pickedResults.size]);

  useEffect(() => {
    setMode(buildingId ? 'building' : 'default');
  }, [buildingId]);

  const actions = isUpload
    ? []
    : [
        {
          icon: <PlaylistAddIcon />,
          tooltipTitle: 'Add search results to project',
          onClick: () => {
            uiStore.setSearchPanelState('picker');
            setMode('picker');
            uiStore.setIsSpeedDialOpen(false);
          },
          isHidden: !['default', 'building'].includes(mode)
        },
        {
          icon: <CloseIcon />,
          tooltipTitle: 'Cancel',
          onClick: () => {
            editorStore.reset();
            mapStore.setBounds(null);
            uiStore.setActiveLayer('satellite', false);
            buildingStore.clearPicked();
            uiStore.setSearchPanelState('search');
            mapStore.setMode('view');
            setMode(buildingId ? 'building' : 'default');
          },
          isHidden: features.length === 0 && !['picker', 'draw'].includes(mode)
        },
        {
          icon: <AddIcon />,
          tooltipTitle: 'Add property to existing project',
          onClick: () => {
            history.push({
              pathname: location.pathname,
              state: {
                modal: true,
                buildings: [{ id: buildingId }]
              }
            });
          },
          isHidden: !['building'].includes(mode)
        }
      ];

  const speedDialIcon = propertyCount ? <CheckIcon /> : <AddIcon />;

  return (
    <SpeedMenu
      actions={actions
        .filter(action => !action.isHidden)
        .filter(
          action =>
            typeof action.isVisible === 'undefined' || action.isVisible === true
        )}
      ariaLabel="Building actions"
      icon={
        <Badge
          classes={{
            badge: 'speed-dial-fab-badge'
          }}
          badgeContent={propertyCount}
          color="primary"
          invisible={propertyCount === 0}
        >
          {speedDialIcon}
        </Badge>
      }
      onClose={() => {
        if (['default', 'building', 'draw'].includes(mode))
          uiStore.setIsSpeedDialOpen(false);
      }}
      onOpen={(event, reason) => {
        if (reason !== 'focus') uiStore.setIsSpeedDialOpen(true);
      }}
      open={isSpeedDialOpen}
      onClick={() => {
        uiStore.setIsSpeedDialOpen(false);
        const buildings = [...buildingStore.pickedResults].map(buldingId => ({
          id: buldingId
        }));
        const allBuildingData = JSON.parse(JSON.stringify([...buildings]));
        if (isUpload) {
          history.push({
            pathname: location.pathname,
            state: {
              modal: true,
              context: 'new-project',
              buildings: allBuildingData
            }
          });
          return;
        }
        if (allBuildingData.length === 0 && buildingId) {
          history.push({
            pathname: location.pathname,
            state: {
              modal: true,
              context: 'new-project',
              buildings: [{ id: buildingId }]
            }
          });
        } else {
          history.push({
            pathname: location.pathname,
            state: {
              modal: true,
              context: 'add-to-project',
              buildings: allBuildingData
            }
          });
        }
      }}
    >
      {mode === 'building' && (
        <Fade in={isSpeedDialOpen}>
          <Typography
            className="speed-dial-tooltip-label default-action"
            variant="body1"
          >
            <span>Create a new project</span>
          </Typography>
        </Fade>
      )}
    </SpeedMenu>
  );
};

export default observer(ProjectSpeedDial);
